export default function getResource(label, vars = []) {
    const resources = {
        widgetError: `Difficulté à se connecter à ${vars[0]}. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.`,
        legalNotice: `En cliquant sur « Continuer à  » ${vars[0]}, je demande à Sephora d’envoyer mes renseignements de commande et de facturation à ${vars[0]} et je comprends que ces renseignements seront assujettis aux conditions ${vars[0]} et à la politique de confidentialité ${vars[0]}.`
    };

    return resources[label];
}
